"use client"

import Image from "next/image"
import { config } from "@/config"
import { Infinity } from "lucide-react"

import { Card, CardContent, CardHeader } from "@/components/ui/card"
import { socialLinks } from "@/components/profile/social-links"
import { ThemeToggle } from "@/components/theme-toggle"

export function MobileLayout() {
  const handleClick = (url: string) => {
    if (typeof window !== "undefined") {
      window.open(url, "_blank", "noopener,noreferrer")
    }
  }

  return (
    <div className="from-background via-background to-muted/20 relative min-h-screen bg-linear-to-br bg-scroll px-2 py-4">
      <div className="mx-auto max-w-md space-y-4">
        <div className="fixed top-6 right-4 z-30">
          <ThemeToggle />
        </div>
        <Card className="relative h-[450px] overflow-hidden">
          <div className="absolute inset-0">
            <Image
              src="/me.jpeg"
              alt={config.name}
              width={4096}
              height={4096}
              className="h-full w-full object-cover select-none"
              draggable={false}
              onContextMenu={(e) => e.preventDefault()}
            />
          </div>
          <CardContent className="from-background/95 via-background/80 absolute right-0 bottom-0 left-0 bg-linear-to-t to-transparent pt-10">
            <div className="space-y-2">
              <h1 className="text-foreground text-2xl font-bold">
                {config.name}
              </h1>
              <p className="pb-6 text-sm">{config.shortDescription}</p>
            </div>
          </CardContent>
        </Card>
        <Card>
          <CardHeader>
            <div className="flex flex-col items-center justify-center">
              <h2 className="from-primary to-primary/60 bg-linear-to-r bg-clip-text text-xl font-bold text-transparent">
                Connect With Me
              </h2>
              <p className="text-muted-foreground mt-1 text-xs sm:text-sm">
                Let&apos;s build something amazing together
              </p>
            </div>
          </CardHeader>
          <CardContent>
            <div className="grid w-full grid-cols-3 justify-center gap-2">
              {socialLinks.map((link, index) => (
                <button
                  key={index}
                  onClick={() => handleClick(link.url)}
                  className="group border-border relative flex h-20 w-full cursor-pointer flex-col items-center justify-center gap-0.5 rounded-xl border px-2 shadow-sm transition-all duration-300 hover:bg-gray-50 active:scale-95"
                  aria-label={link.title}
                >
                  <span className="relative flex size-4 items-center justify-center">
                    {link.icon}
                  </span>
                  <span className="block max-w-full truncate px-1 pt-0.5 text-center text-[10px] font-medium">
                    {link.title}
                  </span>
                </button>
              ))}
            </div>
          </CardContent>
        </Card>
        <div className="grid grid-cols-2 gap-2">
          <Card>
            <CardContent className="flex h-full flex-col items-center justify-center">
              <div className="text-foreground text-xl font-bold">
                {socialLinks.length - 1}+
              </div>
              <div className="text-foreground/70 text-xs">Platforms</div>
            </CardContent>
          </Card>
          <Card>
            <CardContent className="flex h-full flex-col items-center justify-center">
              <div className="text-foreground text-xl font-bold">
                <Infinity className="inline size-7" />
              </div>
              <div className="text-foreground/70 text-xs">Lines</div>
            </CardContent>
          </Card>
          <Card className="col-span-2">
            <CardContent className="flex h-full flex-col items-center justify-center">
              <div className="text-foreground text-xl font-bold">24/7</div>
              <div className="text-foreground/70 text-xs">Building</div>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  )
}
